import React, { Component } from 'react';
import "./style.css";

// import Tile from "arc-design/components/tile";
import { 
  // HelpText, 
  QlikClearSelections, 
  QdtComponent 
} from "../../components";

export default class CityProfile extends Component {

  render() {
    return (
    <div className="cityProfile">    
    
      {/* <div className="sectionHeader"> */}
          <div className="intro">
            <div className="Filter">
              <QdtComponent props={{
                id:"YYDsppX",  //Filter
                height:"35px"
              }}/>
            </div>
            <div className="cityName2">
              <QdtComponent type="QdtKpi" props={{ cols: ["=[City-Country_Comp]"] }} />
            </div>
          </div>
          {/* <div className="clear">
              <QlikClearSelections />
          </div> */}
      {/* </div>   */}
       
      {/* <div className="subsectionTitle">Targets on renewable energy or electricity</div> */}

      <div className="chartwithfooter">
        <div className="chart">
          {/* <div className="chartTitle"></div> */}
            <QdtComponent props={{
              id: "KpVWb",
              height: "270px", 
              noSelections: true
            }} />
        </div> 
        <div className="footnote">
          <div className="footitem">Data sources: World Bank 2018<sup></sup></div>   
        </div> 
      </div>
    </div>      

    );
  }
}
